import { SVGComponent } from '../../../types';

interface ThreadActionButtonProps {
  text: string;
  icon: SVGComponent;
  onClick: () => void;
  'aria-label': string;
}

export const ThreadActionButton: React.FC<ThreadActionButtonProps> = ({
  text,
  icon: Icon,
  onClick,
  'aria-label': ariaLabel,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className="group flex items-center gap-xs rounded-[40px] bg-neutral-200 p-s text-body2Regular text-neutral-800 hover:bg-neutral-300 s:py-xs"
      onClick={onClick}
    >
      <Icon className="size-l text-neutral-600 group-hover:text-neutral-800" />
      <span>{text}</span>
    </button>
  );
};
